import React from 'react';
import { motion } from 'framer-motion';

const ProgressBlinker = ({ isVisible, message = "Processing..." }) => {
  if (!isVisible) return null;

  return (
    <motion.div
      className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
    >
      <div className="glass backdrop-blur-lg border border-blue-400/30 bg-blue-500/20 text-blue-300 px-6 py-3 rounded-glass shadow-lg">
        <div className="flex items-center gap-3">
          <motion.div
            className="w-3 h-3 bg-blue-400 rounded-full"
            animate={{
              opacity: [1, 0.3, 1],
              scale: [1, 0.8, 1]
            }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          <span className="text-sm font-medium">{message}</span>
        </div>
      </div>
    </motion.div>
  );
};

export default ProgressBlinker;